import React from 'react'
import HomeSlider from '../components/home/HomeSlider'
import OurCategories from '../components/home/OurCategories'
import UniqueSection from '../components/home/UniqueSection'
import PerfectHammock from '../components/home/PerfectHammock'
import LatestProducts from '../components/home/LatestProducts'
import TimeOffer from '../components/home/TimeOffer'
import HappyCustomer from '../components/home/HappyCustomer'
import SendMessage from '../components/home/SendMessage'
import NeedOfCustomDesign from '../components/home/NeedOfCustomDesign'
import FollowOnInstagram from '../components/home/FollowOnInstagram'
import AboutUsSection from '../components/aboutus/AboutUsSection'
const Home = () => {
  return (
    <>
      <HomeSlider />
      <OurCategories />
      <AboutUsSection background={true} />
      <UniqueSection />
      <PerfectHammock />
      <LatestProducts />
      {/* <TimeOffer /> */}
      <HappyCustomer />
      <SendMessage />
      <NeedOfCustomDesign />
      <FollowOnInstagram />
    </>
  )
}

export default Home